









import { Component, Prop, Vue } from 'vue-property-decorator';


@Component
export default class Plan extends Vue {
    private loading = false;

    created() {
        this.reload();
    }

    reload() {

    }
}
